import PropTypes from 'prop-types';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import configData from '../../config';
import { LOGOUT } from '../../store/actions'  
//-----------------------|| AUTH GUARD ||-----------------------//


/**
 * AuthGuard component is a high-order component that checks if the user is
 * authenticated by making a request to the server. If the user is not authenticated,
 * it redirects them to the login page. If the user is authenticated, it renders the
 * children components.
 *
 * @param {Object} props - The component props.
 * @param {React.ReactNode} props.children - The child components.
 *
 * @return {React.ReactNode} The rendered children components if the user is authenticated,
 * a Navigate component to the login page otherwise.
 */
const AuthGuard = ({ children }) => {
    const account = useSelector((state) => state.account);
    const { isLoggedIn, token } = account;
    const dispatcher = useDispatch();
    
    /**
     * Checks if the user is authenticated by making a request to the server.
     * If the request is successful, it renders the children components.
     * If the request fails with a 401 status code, it dispatches the LOGOUT action
     * and redirects the user to the login page.
     * If the request fails for any other reason, it redirects the user to the login page.
     *
     * @return {React.ReactNode} The rendered children components if the user is authenticated,
     * a Navigate component to the login page otherwise.
     */
    if (!isLoggedIn) {
        return <Navigate to="/login" />;
    } 
    else {
        
        try {
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            axios.get( configData.API_SERVER + 'home/', {})
            .then(function (response) {
                console.log('session valid', )
            })
            .catch((err)=> {
                if (err.response.status == 401){
                    console.log('session expired err' )
                    dispatcher({ type: LOGOUT });
                    return <Navigate to="/login" />
                }
            })
        }catch (err){
            console.log('not able check the authentication')

            return <Navigate to="/login" />
        }
    }
    return children;
};

AuthGuard.propTypes = {
    children: PropTypes.node
};

export default AuthGuard;
